
export const featuredFirms = [
    {
      id: 1,
      name: "Bufete García & Asociados",
      specialty: "Derecho Civil",
      rating: 4.8,
      image: "/placeholder.svg?height=200&width=300",
    },
    {
      id: 2,
      name: "Martínez Legal",
      specialty: "Derecho Penal",
      rating: 4.7,
      image: "/placeholder.svg?height=200&width=300",
    },
    {
      id: 3,
      name: "Rodríguez & Partners",
      specialty: "Derecho Corporativo",
      rating: 4.9,
      image: "/placeholder.svg?height=200&width=300",
    },
    {
      id: 4,
      name: "López & Asociados",
      specialty: "Derecho Laboral",
      rating: 4.6,
      image: "/placeholder.svg?height=200&width=300",
    },
    {
      id: 5,
      name: "Fernández Abogados",
      specialty: "Derecho Fiscal",
      rating: 4.8,
      image: "/placeholder.svg?height=200&width=300",
    },
    {
      id: 6,
      name: "Sánchez Legal Group",
      specialty: "Derecho Mercantil",
      rating: 4.7,
      image: "/placeholder.svg?height=200&width=300",
    },
  ]